import { render, staticRenderFns } from "./JcomDashboard.vue?vue&type=template&id=d32bbe2e"
import script from "./JcomDashboard.vue?vue&type=script&lang=js"
export * from "./JcomDashboard.vue?vue&type=script&lang=js"
import style0 from "./JcomDashboard.vue?vue&type=style&index=0&id=d32bbe2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports